import { useSelector } from 'react-redux';
import { useNormalizedFolderStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import { useMemo } from 'react';
import {
  getGallectionSectionType,
  getSelectedFolderId,
} from '../../../../selectors/gallectionSection';
import {
  getStreamIdForGallectionType,
  filterOutEmpty,
} from '../../../../utils/gallection';
import { AppState } from '../../../../../types/store';

export function useGallectionFolders() {
  const { streamId, gallectionType, selectedFolderId } = useSelector(
    (state: AppState) => {
      // eslint-disable-next-line @typescript-eslint/no-shadow
      const gallectionType = getGallectionSectionType(state);
      return {
        streamId: getStreamIdForGallectionType(gallectionType),
        gallectionType,
        selectedFolderId: getSelectedFolderId(state),
      };
    }
  );
  const { items: folders, ...stream } = useNormalizedFolderStream(
    streamId,
    gallectionType
  );

  return {
    ...stream,
    folders,
    selectedFolderId,
  };
}

export function useNonEmptyGallectionFolders() {
  const { folders, ...rest } = useGallectionFolders();
  const filteredFolders = useMemo(() => filterOutEmpty(folders), [folders]);
  return {
    ...rest,
    folders: filteredFolders,
  };
}
